import React from "react";

export default function Message({ content }) {
  if(content === 'loaderX'){
    return (<>
    <div class="typing-indicator">
      <span></span>
      <span></span>
      <span></span>
    </div>
    </>)
  }
  const parseText = (text) => {
    if (typeof text !== "string") return text;

    const regex = /(\bhttps?:\/\/[^\s)]+|\*\*.*?\*\*|<[^>]+>|<\/[^>]+>)/gi;

    const parts = text.split(regex);
    let result = [];
    let isInsideLink = false;
    let currentLinkProps = {};

    parts.forEach((part, index) => {
      if (part.startsWith("<a ")) {
        isInsideLink = true;
        const hrefMatch = part.match(/href="(.*?)"/);
        const targetMatch = part.match(/target="(.*?)"/);
        const relMatch = part.match(/rel="(.*?)"/);
        const styleMatch = part.match(/style="(.*?)"/);

        currentLinkProps = {
          href: hrefMatch ? hrefMatch[1] : "",
          target: targetMatch ? targetMatch[1] : "_blank",
          rel: relMatch ? relMatch[1] : "noopener noreferrer",
          style: {
            color: "#87b048", // Green for links
            ...(styleMatch
              ? { [styleMatch[1].split(":")[0]]: styleMatch[1].split(":")[1].trim() }
              : {}),
          },
        };
      } else if (part === "</a>") {
        isInsideLink = false;
      } else if (isInsideLink) {
        result.push(
          <a key={index} {...currentLinkProps}>{part}</a>
        );
      } else if (part.match(/\bhttps?:\/\/[^\s)]+/i)) {
        result.push(
          <a key={index} href={part} target="_blank" rel="noopener noreferrer" style={{color:"#87b048" }}>
            Click Here
          </a>
        );
      } else if (part.startsWith("**") && part.endsWith("**")) {
        result.push(<b key={index}>{part.slice(2, -2)}</b>);
      } else {
        result.push(part);
      }
    });

    return result;
  };

  const cleanContent = (text) => {
    if (typeof text !== "string") return text;
    return text.replace(/【[^】]*】/g, "").trim(); // Remove unwanted characters and trailing spaces
  };

  const renderMessage = (text) => {
    if (typeof text !== "string") return null;
    const cleanedText = cleanContent(text);
    return cleanedText.split("\n").map((line, index) => <p key={index}>{parseText(line)}</p>);
  };
  
  return <>{renderMessage(content)}</>;
}
